import type from './DPPModule.type';

const initialState = {
  dppProductDataById: {},
  devProductData: {},
  factoriesData: [],
  productBOM: [],
  dppSelectedBOMData: [],
};

const DPPProductReducer = (state = initialState, action) => {
  switch (action.type) {
    case type.FETCH_DPP_DATA_BY_ID:
      return {
        ...state,
        dppProductDataById: action?.payload,
      };
    case type.CLEAR_DPP_LIB_DATA:
      return {
        ...state,
        dppProductDataById: {},
      };
    case type.GET_PRODUCT_DETAILS:
      return {
        ...state,
        devProductData: action?.payload,
      };
    case type.GET_FACTORIES_DETAIL:
      return {
        ...state,
        factoriesData: action?.payload,
      };
    case type.GET_DPP_BOM:
      return {
        ...state,
        productBOM: action?.payload,
      };
    case type.FETCH_SELECTED_BOM_DATA:
      return {
        ...state,
        dppSelectedBOMData: action?.payload,
      };
    default:
      return state;
  }
};

export default DPPProductReducer;
